import { h } from '@stencil/core';
import noop from 'lodash/noop';
import { ESectionHeaderColors } from '@pes-ui/utils';
import cn from 'classnames';
export class SectionHeader {
  constructor() {
    this.color = ESectionHeaderColors.DEFAULT;
    this.isInProductsFilters = false;
    this.el.dir = document.documentElement.dir || 'auto';
  }
  render() {
    return (h("qds-title", { class: cn(`section-heading section-heading--color-${this.color}`, this.isInProductsFilters && 'section-heading--in-products-filters'), layer: "main", level: "subsection", variant: "web-main-section-hero", alignment: "start", onClick: noop }, h("slot", null)));
  }
  static get is() { return "pes-section-header"; }
  static get encapsulation() { return "shadow"; }
  static get originalStyleUrls() {
    return {
      "$": ["section-header.scss"]
    };
  }
  static get styleUrls() {
    return {
      "$": ["section-header.css"]
    };
  }
  static get properties() {
    return {
      "color": {
        "type": "string",
        "mutable": false,
        "complexType": {
          "original": "SectionHeaderColors",
          "resolved": "ESectionHeaderColors.DEFAULT | ESectionHeaderColors.FUCHSIA | ESectionHeaderColors.INHERIT",
          "references": {
            "SectionHeaderColors": {
              "location": "import",
              "path": "@pes-ui/utils"
            }
          }
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": "Defines the header color. By default $se-life-green."
        },
        "attribute": "color",
        "reflect": false,
        "defaultValue": "ESectionHeaderColors.DEFAULT"
      },
      "isInProductsFilters": {
        "type": "boolean",
        "mutable": false,
        "complexType": {
          "original": "boolean",
          "resolved": "boolean",
          "references": {}
        },
        "required": false,
        "optional": false,
        "docs": {
          "tags": [],
          "text": ""
        },
        "attribute": "is-in-products-filters",
        "reflect": false,
        "defaultValue": "false"
      }
    };
  }
  static get elementRef() { return "el"; }
}
